import { useCallback } from "react";

import {
  presentRequestFailure,
  type PresentRequestFailureMode,
  type PresentedRequestFailure,
} from "../../lib/errors/present-request-failure";
import { useAppI18n } from "../../i18n/context";

/** 把原始异常转为带标题、说明与恢复计划的展示结构。 */
export const usePresentUserFacingError = () => {
  const { t } = useAppI18n();

  return useCallback(
    (
      error: unknown,
      mode: PresentRequestFailureMode,
      fallback = t("errors.unavailableDetail"),
    ): PresentedRequestFailure =>
      presentRequestFailure(error, mode, t, fallback),
    [t],
  );
};
